import NotificationManager from 'react-hot-toast';

export const Toast = ({ type = 'success', message, messageDesc, duration = 3000 }) => {
  if (typeof globalThis.window === 'undefined') {
    return;
  }

  if (type === 'error' && typeof navigator !== 'undefined' && navigator.onLine === false) {
    return;
  }

  if (Array.isArray(message)) {
    let item;
    for (item of message) {
      NotificationManager[type](item.message, { duration, ...item });
    }
  } else {
    NotificationManager[type](message, {
      duration,
      messageDesc,
    });
  }
};
